import { render, staticRenderFns } from "./BaseTLModalDialog.vue?vue&type=template&id=b9b5e0fc&"
import script from "./BaseTLModalDialog.vue?vue&type=script&lang=ts&"
export * from "./BaseTLModalDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports